/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { Text as DefText } from '../../components/texts';

export const BlockText = styled(DefText)`
  margin-bottom: 10px;
`;
